<app-breadcrumb [title]="'Preview Application Details'"></app-breadcrumb>


<app-loader [show]="skeleton"></app-loader>
<div [class.d-none]="skeleton">
  <div class="row">
  <div class="col-md-3 bg-white rounded shadow">
    <div class="pl-3 pr-5">
      <app-navbar [step]="0">
      </app-navbar>
    </div>
  </div>
  <div class="col-md-9">
    <div class="border rounded p-3 mb-3">
        <div class="d-flex justify-content-between align-items-center pb-2 mb-3 border-bottom">
            <h3 class="h6 fw-bold mb-0">Photo & Sign</h3>
            <a [routerLink]="['/employee/profile/thumb']" class="btn btn-primary btn-sm rounded-0">EDIT</a>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="text-center">
                    <span class="fw-bold mr-2">Photo:</span>
                    <img alt="no-image" [src]="pic" class="img-fluid border mt-2" width="128" height="128">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="text-center">
                    <span class="fw-bold mr-2">Sign:</span>
                    <img alt="no-image" [src]="sin" class="img-fluid border mt-2" width="128" height="128">
                </div>
            </div>
        </div>
    </div>

    <app-employee-view *ngIf="transferRequest" [profile]="transferRequest.profile" [transferRequest]="transferRequest">
    </app-employee-view>

    <div class="mb-3 d-flex justify-content-start"
        *ngIf="transferRequest && transferRequest.profile && transferRequest.isTransfer">
        <span class="fw-bold mr-2">Claimed Category:</span>
        <span [innerHtml]="getCategories(transferRequest.profile)"></span>
    </div>

    <div class="alert alert-info">
        <span class="fw-bold">Note:</span> Please If you find any wrong information, please click "Edit" button on the
        right side of the relevant section to edit the desired field.
    </div>

    <div class="d-flex justify-content-end">
        <button *ngIf="transferRequest && !transferRequest.isConfirm" type="button" (click)="confirm()"
            class="btn btn-danger rounded-0">Lock Application</button>
    </div>
</div>
</div>
</div>
